import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import ForecastsChart from '../common/charts/ForecastsChart';
import Methodology from '../common/Methodology';

import { setCountry1, setCountry2, setCountry3 } from '../../actions';

import { forecastTab } from '../../model/subMenuTabs';

import { getTotalValue } from '../../api';

const Forecasts = props => {

    let selected = '', secondLevel = '', selectedSecondLevel = '';
    for (let i = 0; i < forecastTab.length; i++)
    {
        if (props.indicator == forecastTab[i].url)
        {
            selected = forecastTab[i];
        }
    }

    if(selected.subTabs != undefined) {
        secondLevel = selected.subTabs;
        for (let i = 0; i < secondLevel.length; i++){

            if(props.subIndicator == secondLevel[i].url){
                selectedSecondLevel = secondLevel[i];
            }
        }
    }

    const currentPath = '/osh-context/forecasts/';
    const indicator = props.indicator;
    const firstLevelTabs = forecastTab;

    // Get global state for the selects
    const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
    const [secondLevelTabs, setSecondLevelTabs] = useState(secondLevel);
    const [selectedTab, setSelectedTab] = useState(selected);
    const [selectedSecondLevelTab, setSelectedSecondLevelTab] = useState(selectedSecondLevel);
    const [totalTopValue, setTotalTopValue] = useState(null);
    
    // Hook for the dispatchs
    const dispatch = useDispatch();

    useEffect(() => {
        // Update the title of the page
        document.title = props.literals.L20695 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
		// window.addEventListener('resize', updateDimension);

        if (selectedByUser) {
            return null
        } else {
            if (props.country1 != undefined && props.country1 != '') {
                dispatch(setCountry1(props.country1))
            }
        }

        if (props.country2 != undefined && props.country2 != '') {
            dispatch(setCountry2(props.country2))
        }

        if (props.country3 != undefined && props.country3 != '') {
            dispatch(setCountry3(props.country3))
        }
    }, [])

    useEffect(() => {
        if (selectedSecondLevelTab.url == 'top-sectors-employment' || selectedSecondLevelTab.url == 'top-occupations-employment' || selectedSecondLevelTab.url == 'job-openings-by-occupation') 
        {
            dispatch(setCountry2(''));
            dispatch(setCountry3(''));
        }
    }, [selectedSecondLevelTab])

    useEffect(() => {
        if(selectedSecondLevelTab.url == 'top-sectors-employment' || selectedSecondLevelTab.url == 'top-occupations-employment') {
            calculateTotalTopValue(selectedSecondLevelTab.chartType[0], props.selectedByUser ? lockedCountry : props.selectCountry)
        }
    }, [props.selectCountry])

    useEffect(() => {
        if((selectedSecondLevelTab.url == 'top-sectors-employment' || selectedSecondLevelTab.url == 'top-occupations-employment') && totalTopValue == null) {
            calculateTotalTopValue(selectedSecondLevelTab.chartType[0], props.selectedByUser ? lockedCountry : props.selectCountry)
        }
    }, [selectedSecondLevelTab, totalTopValue])

    const calculateTotalTopValue = (chart, country1) => {
        getTotalValue(chart.chart, chart.chartIndicator, country1)
        .then((data) => {
            if(data.resultset != undefined){
                setTotalTopValue(data.resultset)
            }
        })
    }

    const handleSearch = (callbackCountry1) =>{
		if (selectedByUser) {
            setCountryLocked(callbackCountry1)
        } else {
            dispatch(setCountry1(callbackCountry1))
        }
	}

	const handleSearch2 = (callbackCountry2) =>{
		dispatch(setCountry2(callbackCountry2));
	}

	const handleSearch3 = (callbackCountry3) =>{
		dispatch(setCountry3(callbackCountry3));
	}

    const callbackSelectedTab = (callback) => {
        //This function will be called when changing between the first level tabs
        for (let i = 0; i < firstLevelTabs.length; i++){
            if(callback == firstLevelTabs[i].url){
                let newSelectedTab = firstLevelTabs[i];
                setSelectedTab(newSelectedTab);
                setSecondLevelTabs(newSelectedTabs.subTabs);
                setSelectedSecondLevelTab(newSelectedTab.subTabs[0]);
            }
        }
	}

    const callbackSelectedIndicator = (callback) => {
        for (let i = 0; i < secondLevelTabs.length; i++)
        {
            if( callback == secondLevelTabs[i].url )
            {
                let newSelectedTab = secondLevelTabs[i];
                setSelectedSecondLevelTab(newSelectedTab);
            }
        }
    }

    // set indicator that will be requested for the methodology
    const indicatorID = selectedSecondLevelTab.chartType[0].chartIndicator;

    let selectEconomic = <SelectEconomic 
        handleSearch= { handleSearch }  
        handleSearch2= { handleSearch2 } 
        handleSearch3= { handleSearch3 }
        charts= { [ selectedSecondLevelTab.chartType[0].chart ] }
        indicator= { selectedSecondLevelTab.chartType[0].chartIndicator }
        literals= { props.literals }
        selectedCountry1= { selectedByUser ? countryLocked : selectCountry }
        selectedCountry2= { selectCountry2 }
        selectedCountry3= { selectCountry3 }
    />;

    if (selectedSecondLevelTab.url == 'top-sectors-employment' || selectedSecondLevelTab.url == 'top-occupations-employment' || selectedSecondLevelTab.url == 'job-openings-by-occupation') {
        selectEconomic = <SelectEconomic 
            handleSearch= { handleSearch } 
            charts= { [ selectedSecondLevelTab.chartType[0].chart ] }
            indicator= { selectedSecondLevelTab.chartType[0].chartIndicator }
            literals= { props.literals }
            selectedCountry1= { selectedByUser ? countryLocked : selectCountry }
            selectedCountry2= { selectCountry2 }
            selectedCountry3= { selectCountry3 }
            selectOneCountry= { true }
        />
    }
    
    const chartLegend = selectedSecondLevelTab.chartType[0].legend;

    return(
        <div className="forecasts">
            {/* Add resize for className forecasts */}
            <AdviceSection literals= { props.literals } section= { ["osh-context","forecasts"] } methodologyData= { { section: 'osh-context', subsection: 'Forecasts', indicator: 423 } } />

            <div className='second--submenu'>
                <div className="line background-main-light" />
                <SubMenuTabs 
                    literals = { props.literals }
                    selectedTab = { selectedSecondLevelTab.url }
                    callbackSelectedTab = { callbackSelectedIndicator }
                    locationPath = { `${currentPath}${indicator}/` }
                    subMenuTabs= { secondLevelTabs }
                />
            </div>
            <div className="line background-main-light" />

            { ( selectedSecondLevelTab.url != 'employment-growth') && (
                <React.Fragment>
                    { selectEconomic }
                </React.Fragment>
            )}
            <div className="line background-main-light" />

            <div className='container section--page no--padding card--grid xxs-w1 xs-w1 w1 center-text'>
                <div className="card--block--chart no-filters">
                    {
                        selectedSecondLevelTab.url == 'employment-growth' && (
                            <div className="chart--block">
                                <ForecastsChart
                                    width = "450"
                                    literals = { props.literals }
                                    chartType = { selectedSecondLevelTab.chartType }
                                    decimalNumbers = { 1 }
                                    percentage = { true }
                                />
                            </div>

                        )
                    }
                    {
                        (selectedSecondLevelTab.url == 'employment-growth-sector' || selectedSecondLevelTab.url == 'labour-force-growth-age')  && (
                            <div className="chart--block">
                                <ForecastsChart
                                    width = "450"
                                    literals = { props.literals }
                                    chartType = { selectedSecondLevelTab.chartType }
                                    showAbsoluteValue = { true }
                                    decimalNumbers = { 0 }
                                    country1 = { selectedByUser ? countryLocked : selectCountry }
                                    country2 = { selectCountry2 }
                                    country3 = { selectCountry3 }
                                />
                            </div>
                        )
                    }
                    {
                        (selectedSecondLevelTab.url == 'top-sectors-employment')  && (
                            <React.Fragment>
                                <div className="chart--block">
                                    <ForecastsChart
                                        width = "450"
                                        literals = { props.literals }
                                        chartType = { selectedSecondLevelTab.chartType }
                                        decimalNumbers = { 1 }
                                        percentage = { true }
                                        country1 = { selectedByUser ? countryLocked : selectCountry }
                                        country2 = { selectCountry2 }
                                        country3 = { selectCountry3 }
                                    />
                                </div>
                                <label className='card--dataset--info'>{ props.literals.L20760 } { totalTopValue }</label>
                            </React.Fragment>
                        )
                    }
                    {
                        (selectedSecondLevelTab.url == 'top-occupations-employment')  && (
                            <React.Fragment>
                                <div className="chart--block">
                                    <ForecastsChart
                                        width = "450"
                                        literals = { props.literals }
                                        chartType = { selectedSecondLevelTab.chartType }
                                        decimalNumbers = { 1 }
                                        percentage = { false }
                                        country1 = { selectedByUser ? countryLocked : selectCountry }
                                        country2 = { selectCountry2 }
                                        country3 = { selectCountry3 }
                                    />
                                </div>
                                <label className='card--dataset--info'>{ props.literals.L20760 } { totalTopValue }</label>
                            </React.Fragment>
                        )
                    }
                    {
                        selectedSecondLevelTab.url == 'job-openings-by-occupation' && (
                            <div className="chart--block">
                                <ForecastsChart
                                    width = "450"
                                    literals = { props.literals }
                                    chartType = { selectedSecondLevelTab.chartType }
                                    decimalNumbers = { 0 }
                                    percentage = { false }
                                    country1= { selectedByUser ? countryLocked : selectCountry }
                                    country2= { selectCountry2 }
                                    country3= { selectCountry3 }
                                />
                            </div>
                        )
                    }
                    
                </div>
                <div className="chart-legend">
                    {ReactHtmlParser(props.literals[`L${chartLegend}`])}
                </div>
            </div>

            <Methodology literals = { props.literals } section = { 'Forecasts' } indicator = { indicatorID } />
        </div>
    )
}

Forecasts.displayName = 'Forecasts';
export default Forecasts;